import axios from 'axios';
import ErrorService from './services/ErrorService';

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            ErrorService.reportErrorFromRequest(error);
        }
        if (error.cause) {
            console.error('Network error cause:', error.cause);
        }
        return Promise.reject(error);
    }
);
